import {
  Component,
  ElementRef,
  effect,
  input,
  ViewChild,
  AfterViewInit
} from '@angular/core';

import JsBarcode from 'jsbarcode';

@Component({
  selector: 'ui-barcode',
  standalone: true,
  imports: [],
  template: `<svg #barcodeSvg style="width: 100%; display: block;"></svg>`,
  styles: [
    `
      :host {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    `
  ]
})
export class BarcodeComponent implements AfterViewInit {
  value = input.required<string>();
  format = input<string>('CODE128');
  displayValue = input<boolean>(true);
  width = input<number>(2);
  height = input<number>(46);
  @ViewChild('barcodeSvg') barcodeEl!: ElementRef<SVGElement>;

  constructor() {
    effect(() => {
      this.generateBarcode();
    });
  }

  ngAfterViewInit() {
    this.generateBarcode();
  }

  private generateBarcode() {
    if (!this.barcodeEl || !this.barcodeEl.nativeElement) {
      return;
    }
    const currentValue = this.value();
    if (!currentValue) {
      this.barcodeEl.nativeElement.innerHTML = '';
      return;
    }

    try {
      JsBarcode(this.barcodeEl.nativeElement, currentValue, {
        format: this.format(),
        displayValue: this.displayValue(),
        width: this.width(),
        height: this.height(),
        margin: 20,
        fontSize: 18
      });
    } catch (e: any) {
      console.error(`[BarcodeComponent] Ошибка генерации: ${e.message}`);
      this.barcodeEl.nativeElement.innerHTML = '';
    }
  }
}
